const template = require(`./templates/${process.env.ENTRY_POINT}/modal-overlay.hbs`);
require(`./scss/_dontExtract_/${process.env.ENTRY_POINT}/modal-overlay.scss`);

class ModalOverlay {
  constructor(options) {
    this.props = {
      id: null,
      header: true,
      content: null,
      title: null,
      width: undefined,
      maxWidth: undefined,
      height: undefined,
      onClose: null,
      beforeOnClose: null,
      destroyOnClose: false,
      onOpen: null,
      targetElem: null,
    };

    this.props = Object.assign({}, this.props, options);

    if (this.props.id === null || typeof this.props.id !== 'string') {
      throw new Error('ModalOverlay: property ID is required and must be a string.');
    }

    this.modalOpen = false;

    this.toggleOpen = () => {
      this.modalOpen = !this.modalOpen;
    };

    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);

    let container = document.createElement('div');

    container.innerHTML = template({
      id: this.props.id,
      content: this.props.content,
      title: this.props.title,
      header: this.props.header,
      width: typeof this.props.width === 'number' ? `${this.props.width}px` : this.props.width,
      maxWidth: this.props.maxWidth,
      height: this.props.height,
    });

    document.body.appendChild(container.firstChild);

    document.addEventListener('click', this.handleBackdropClick, true);
    document.addEventListener('click', this.handleCloseButtonClick, true);
    document.addEventListener('keydown', this.handleKeyDown, true);

    this.el = document.getElementById(this.props.id);
    this.titleContainer = this.props.header ? this.el.querySelector('.overlay-header') : null;
    this.contentContainer = this.el.querySelector('.overlay-content-container');
    container = null;
  }

  close(event) {
    if (this.modalOpen === false) {
      return;
    }

    if (this.props.beforeOnClose !== null && typeof this.props.beforeOnClose === 'function') {
      if (this.props.beforeOnClose() === false) {
        return;
      }
    }

    // this.el.style.display = 'none';
    this.el.classList.remove('visible');
    document.body.classList.remove('disable-scroll');
    this.focusedElBeforeOpen.focus();
    this.toggleOpen();

    if (this.props.onClose !== null && typeof this.props.onClose === 'function') {
      this.props.onClose(event);
    }

    if (this.props.destroyOnClose === true) {
      this.destroy();
    }
  }

  open() {
    if (this.modalOpen === true) {
      return;
    }

    // this.el.style.display = 'block';
    this.el.classList.add('visible');
    document.body.classList.add('disable-scroll');
    this.focusedElBeforeOpen = this.props.targetElem || document.activeElement;
    this.setFocus();
    this.toggleOpen();

    if (this.props.onOpen !== null && typeof this.props.onOpen === 'function') {
      this.props.onOpen();
    }
  }

  destroy() {
    if (this.el.parentNode === null) {
      return;
    }

    document.body.classList.remove('disable-scroll');
    document.removeEventListener('click', this.handleCloseButtonClick, true);
    document.removeEventListener('click', this.handleBackdropClick, true);
    document.removeEventListener('keydown', this.handleKeyDown, true);
    this.el.parentNode.removeChild(this.el);
  }

  isOpen() {
    return this.modalOpen;
  }

  setFocus() {
    const overlay = document.getElementById(`${this.props.id}-content`);
    const focusElements = overlay.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    const firstElIndex = 0;

    this.focusableElements = Array.prototype.slice.call(focusElements);
    this.firstFocusElement = this.focusableElements[firstElIndex];
    this.lastFocusElement = this.focusableElements[this.focusableElements.length - 1];
    this.firstFocusElement.focus();
  }

  handleKeyDown(event) {
    const TAB_KEY = 9;
    const ESC_KEY = 27;
    const { keyCode, shiftKey } = event;

    if (ESC_KEY === keyCode) {
      this.close(event);
    } else if (TAB_KEY === keyCode) {
      if (this.focusableElements.length === 1) {
        event.preventDefault();
        return;
      }

      if (shiftKey) {
        if (document.activeElement === this.firstFocusElement) {
          event.preventDefault();
          this.lastFocusElement.focus();
        }
      } else if (document.activeElement === this.lastFocusElement) {
        event.preventDefault();
        this.firstFocusElement.focus();
      }
    }
  }

  handleCloseButtonClick(event) {
    if (event.target.classList.contains('overlay-close-btn')) {
      this.close(event);
      event.preventDefault();
    }
  }

  handleBackdropClick(event) {
    if (event.target.id === this.props.id) {
      this.close(event);
    }
  }

  setTitle(title) {
    if (!this.titleContainer) {
      return;
    }
    const formattedTitle = `<h1>${title}</h1>`;
    this.titleContainer.innerHTML = formattedTitle;
  }

  setContent(content) {
    this.contentContainer.innerHTML = content;
  }
}

export default ModalOverlay;
